import { Injectable } from '@angular/core';

export interface NormalisableFile {
  name: string;
  fileExtension?: string;
  contentSubType?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContentTypeMapperService {
  private readonly mimeTypeToExtension: Map<string, string>;

  constructor() {
    this.mimeTypeToExtension = new Map<string, string>([
      ['pdf', 'pdf'],
      ['application/pdf', 'pdf'],

      ['doc', 'doc'],
      ['docx', 'docx'],
      ['msword', 'doc'],
      ['application/msword', 'doc'],
      ['application/vnd.ms-word', 'doc'],
      ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'docx'],
      ['vnd.openxmlformats-officedocument.wordprocessingml.document', 'docx'],

      ['png', 'png'],
      ['jpg', 'jpg'],
      ['jpeg', 'jpeg'],
      ['gif', 'gif'],
      ['image/png', 'png'],
      ['image/jpeg', 'jpeg'],
      ['image/jpg', 'jpg'],
      ['image/gif', 'gif'],

      ['txt', 'txt'],
      ['text', 'txt'],
      ['plain', 'txt'],
      ['text/plain', 'txt'],
      ['vtt', 'vtt'],

      ['mp3', 'mp3'],
      ['mpeg', 'mp3'],
      ['mpga', 'mp3'],
      ['audio/mpeg', 'mp3'],
      ['audio/mp3', 'mp3'],
      ['wav', 'wav']
    ]);
  }

  normaliseFileExtension(file: any, fixName?: boolean): any {
    if (file.contentSubType) {
      const mappedExtension = this.mapContentTypeToExtension(file.contentSubType);
      if (mappedExtension) {
        file.fileExtension = mappedExtension;
        if (fixName && file.name) {
          file.name = this.fixFilename(file, file.fileExtension);
        }
        return file;
      }
    }

    if (file.name && file.name.includes('.')) {
      const parts = file.name.split('.');
      const ext = parts[parts.length - 1];
      file.fileExtension = ext.toLowerCase();
    }

    return file;
  }

  public mapContentTypeToExtension(contentSubType: string): string | undefined {
    if (!contentSubType) {
      return undefined;
    }

    const normalised = contentSubType.toLowerCase().trim();

    if (this.mimeTypeToExtension.has(normalised)) {
      return this.mimeTypeToExtension.get(normalised);
    }

    return undefined;
  }

  private fixFilename(file: any, newExt: string) {
    const parts = file.name.split('.');
    const partsExcludeExt = parts?.length > 1 ? parts.slice(0, -1) : parts;
    return partsExcludeExt.join() + '.' + newExt;
  }
}
